<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0"> {{ $t("shipping_return") }} </h6>
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4" >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <router-link to="/backoffice/packings">
                        <base-button size="md" type="neutral">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-4">
                <div>
                    <card header-classes="bg-transparent" footer-classes="bg-transparent" body-classes="px-lg-4 py-lg-4" class=" border-0  mb-4" >

						<div class="row" >
                                <div class="col-md-12">
                                    <base-input
                                        :placeholder="$t('scanbarcode')"
                                        v-model="barcode"
                                        class="form-control-alternative"
                                        prepend-icon="ni ni-zoom-split-in"
										v-on:keyup.enter="handleBarcode"
                                    ></base-input>
                                </div>
                              
                            </div>

						<!-- Show Order ID -->


  
                             
                    </card>
                </div>
            </div>

            <div class="container-fluid mt--6 col-lg-8">
                <div>
                    <!-- card right -->
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label class="col-md-6 col-form-label form-control-label" >
                                    <h3 class="mb-0" v-if="params.id == '' || params.id == 0"> {{ $t("order_information") }} </h3>
                                    <h3 class="mb-0" v-else> {{ $t("order_information") }} : {{  this.params.id }} </h3>

									<h3 v-if="params.tracking_number != ''">Tracking : {{  this.params.tracking_number }}</h3>
                                </label>
                            </div>
                        </template>
                        <div>
                            <!-- Selected Product -->
                            <div class="row">
                                <div class="col-md-12">
                                    <el-table :data="order_items" row-key="id" header-row-class-name="thead-light">
                                        <!-- Productname -->

										<el-table-column :label="$t('product_image')" min-width="200px"> 
											<template slot-scope="{ row }"> 
												<img :src="GetProductImage(row.wms_product_id)" wdith="200px" height="200px" />
											</template> 
										</el-table-column>

                                        <el-table-column :label="$t('product_name')" min-width="300px"> 
											<template slot-scope="{ row }" > 
												<h2>
												<span class="text-green" v-if="row.pickup_need == null"> {{ row.wms_product_name }} </span>
												<span  v-else> {{ row.wms_product_name }} </span>
												</h2>

											
											</template> 
										</el-table-column>

                                        <!-- quantity -->
                                        <el-table-column  :label="$t('product_pickup')">
                                            <template slot-scope="{  row }" >
                                                <span >  {{  row.pickup_quantity }} </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            

                           
                        </div>
                       
                    </card>
                </div>
            </div>
        </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
				Loading...
            </form>

            <template slot="footer">
              
            </template>
        </modal>
    </div>
</template>
<script>
import { shippingFormProviders } from "@/const/shippingProviders";
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
			StorageTableOrg: "WmsStorage/getData",
			// #416 ruling: packing / return rooms verify order contents (barcode + image); old
			// orders with a disabled product must still pack, so this reads the active=all list.
			ProductTable: "WmsProduct/getDataAll",
        }),


		StorageTable() {
			return this.StorageTableOrg.filter((item) => {
				return item.ID != 1;
			});
		},

	

    },
    data() {
        return {

            isLoading: false,
			showModal : false,
			lock:false,
			// mdf-bo-fn#237: the list lives in src/const/shippingProviders.js,
			// mirrored from the back-end table. This page used to carry its own
			// copy with id 5 = มาดามฟิน; the back-end says 5 = DHL, 6 = มาดามฟิน.
			ShippingProviderTable: shippingFormProviders(),

			state : 0,
			barcode : "",
			pickup_items:[], // สินค้าที่หยิบใส่กล่องแล้ว
			order_items:[],  // สินค้าที่เลือกจาก Order

			params: {
				id : 0,
				tracking_number : "",
				barcode : "",
            },
           
            propsToSearch: ["Number", "Email"],
           
        };
    },
    mounted() {
		this.listProduct({ active: "all" });
		this.clearParam();
    },
    methods: {
        ...mapActions({
			createReturn: "Packing/createReturn",
			closeReturn: "Packing/closeReturn",
			listProduct: "WmsProduct/listData",
        }),

		async handleBarcode(){

			console.log("handleBarcode", this.barcode);
			console.log("state", this.state);
			this.showModal = true;

			this.params.barcode = this.barcode;
			this.barcode = ""

			let isOrder = this.params.barcode.startsWith("MDF");
			let orderId = this.params.barcode.replace("MDF", "")

			// Fetch Order ID
			if (isOrder){
				try {
					orderId = parseInt(orderId);
				} catch (error) {
					console.log("error", error);
					this.showModal = false
					swal.fire({
						title: error,
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					return
				}
			}
			console.log("isOrder",isOrder)


			let resp = {}
			
			switch (this.state){
				case 0: // Unknown Order
					if (isOrder){
						try {
							// Query Order
						 	resp = await this.createReturn({
							id: orderId,
							barcode: ""
						});
						} catch (err){
							console.log(err)
							this.showModal = false

							swal.fire({
								title: this.$t(err.response.data.Msg),
								text: err.response.data.Cause,
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});

							return
						}

						this.order_items = resp.data.Datum.order_items
						this.params.id = orderId
						this.params.tracking_number = resp.data.Datum.tracking_number

						console.log(resp.data.Datum)
						console.log(this.params)

						this.state = 1;
						this.showModal = false

					} else {
						this.showModal = false
						swal.fire({
							title: "กรุณาสแกนหมายเลข Order",
							text: "",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
					}
					break;

				case 1:	// พบ Order
					if (isOrder){
						try {
							// Query Order
							resp = await this.createReturn({
							id: orderId,
							barcode: ""
						});
						} catch (err){
							console.log(err)
							this.showModal = false

							swal.fire({
								title: this.$t(err.response.data.Msg),
								text: err.response.data.Cause,
								icon: "error",
								confirmButtonClass: "btn btn-danger btn-fill",
								buttonsStyling: false
							});

							return
						}

						this.order_items = resp.data.Datum.order_items
						this.params.id = orderId
						this.params.tracking_number = resp.data.Datum.tracking_number

						this.state = 1;
						this.showModal = false
						return
					} 

					this.showModal = false 

					if (this.params.tracking_number != this.params.barcode) {
						swal.fire({
							title: "หมายเลข Tracking ไม่ถูกต้อง",
							text: "",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
						return
					}

					



					swal.fire({
						title: "ยืนยันรับสินค้าตีกลับ Order No." + this.params.id + " หรือไม่ ?",
						text: "Tracking No. " + this.params.tracking_number,
						icon: "info",
						showCancelButton: true,
						confirmButtonClass: "btn btn-success btn-fill",
						cancelButtonClass: "btn btn-danger btn-fill",
						confirmButtonText: this.$t("confirm"),
						cancelButtonText: this.$t("cancel"),
						buttonsStyling: false
					}).then(result => {
						if (result.value) {
							let data = {
								id: this.params.id,
								tracking_number: this.params.barcode
							};

							this.closeReturn(data).then(resp => {
								swal.fire({
									title: "Success",
									text: "Order No." + this.params.id + " รับสินค้าตีกลับเรียบร้อย",
									icon: "success",
									confirmButtonClass: "btn btn-success btn-fill",
									buttonsStyling: false
								});
								this.clearParam()
							}).catch((err)=> {
								swal.fire({
									title: "Error",
									text: err,
									icon: "error",
									confirmButtonClass: "btn btn-danger btn-fill",
									buttonsStyling: false
								});
							});
						}
					});
					break;
			}
			
		},

		clearParam(){
			this.order_items =  []
			this.params.id = ""
			this.params.tracking_number = ""
			this.params.barcode = ""
			this.barcode = ""
			this.state = 0
		},

		GetProductImage(id){
			// find product table
			let product = this.ProductTable.find(x => x.ID == id)
			if (product){
				return process.env.VUE_APP_API_BASE_URL + "/files/wms_products/" + product.Image
			} else {
				return ""
			}
		}
    }
};
</script>


<style scoped>
	.el-table td{
		padding: 0  !important;
	} 
</style>